export default "__VITE_ASSET__DTiSGwNG__"